// Avatar-generation socket payload, emitted on the shared `'event'` channel and
// routed by `type: 'ai-avatar'`. On FINISHED, `mediaItems` carries the generated
// video samples as full media items.

import { IMediaItem } from 'types/media'

export enum AIAvatarSocketMessageState {
  PREPARING_AI_VIDEO = 'preparing_ai_video',
  // Mid-render: the voiceover (TTS) has been produced, which is when a free
  // user's gift/credit is actually consumed. Triggers a gift-access re-check so
  // the generate footer reflects the new balance before the full video FINISHES.
  VOICEOVER_GENERATED = 'voiceover_generated',
  FINISHED = 'finished',
  ERROR = 'error'
}

export interface IAIAvatarSocketMessage {
  ai_avatar_project_id: number
  ai_avatar_video_hash: string
  state: AIAvatarSocketMessageState
  type: 'ai-avatar'
  user_id: number

  aiAvatarProjectId?: number
  mediaItems: IMediaItem[]

  // Present on ERROR: backend-supplied human-readable reason (e.g. "No AI
  // credits available."). When set, the failure handler surfaces it verbatim
  // (CUSTOM_API_ERROR) instead of the generic copy.
  message?: string
}
